
export async function instantiate(imports={}, runInitializer=true) {
    imports['_cachedJsObjects_'] = imports['_cachedJsObjects_'] ?? new WeakMap();
    const cachedJsObjects = imports['_cachedJsObjects_'];

    // ref must be non-null
    function getCachedJsObject(ref, ifNotCached) {
        if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
        const cached = cachedJsObjects.get(ref);
        if (cached !== void 0) return cached;
        cachedJsObjects.set(ref, ifNotCached);
        return ifNotCached;
    }


    imports['./skiko.mjs'] = imports['./skiko.mjs'] ?? await import('./skiko.mjs');
    imports['@js-joda/core'] = imports['@js-joda/core'] ?? await import('@js-joda/core');

    const _ref_Li9za2lrby5tanM_ = imports['./skiko.mjs'];
    const _ref_Li9za2lrby5tanM_c2tpa29BcGk = imports['./skiko.mjs'].skikoApi;
    const _ref_QGpzLWpvZGEvY29yZQ_ = imports['@js-joda/core'];

    const wasmJsTag = WebAssembly.JSTag;
    const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

    const js_code = {
        'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
        'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
        'kotlin.wasm.internal.stringLength' : (x) => x.length,
        'kotlin.wasm.internal.jsExportStringToWasm' : (src, srcOffset, srcLength, dstAddr) => { 
            const mem16 = new Uint16Array(wasmExports.memory.buffer, dstAddr, srcLength);
            let arrayIndex = 0;
            let srcIndex = srcOffset;
            while (arrayIndex < srcLength) {
                mem16.set([src.charCodeAt(srcIndex)], arrayIndex);
                srcIndex++;
                arrayIndex++;
            }     
             },
        'kotlin.wasm.internal.externrefToBoolean' : (ref) => Boolean(ref),
        'kotlin.wasm.internal.importStringFromWasm' : (address, length, prefix) => { 
            const mem16 = new Uint16Array(wasmExports.memory.buffer, address, length);
            const str = String.fromCharCode.apply(null, mem16);
            return (prefix == null) ? str : prefix + str;
             },
        'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
        'kotlin.wasm.internal.getJsEmptyString' : () => '',
        'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
        'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
        'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
        'kotlin.wasm.internal.externrefHashCode' : 
        (() => {
        const dataView = new DataView(new ArrayBuffer(8));
        function numberHashCode(obj) {
            if ((obj | 0) === obj) {
                return obj | 0;
            } else {
                dataView.setFloat64(0, obj, true);
                return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
            }
        }
        
        const hashCodes = new WeakMap();
        function getObjectHashCode(obj) {
            const res = hashCodes.get(obj);
            if (res === undefined) {
                const POW_2_32 = 4294967296;
                const hash = (Math.random() * POW_2_32) | 0;
                hashCodes.set(obj, hash);
                return hash;
            }
            return res;
        }
        
        function getStringHashCode(str) {
            var hash = 0;
            for (var i = 0; i < str.length; i++) {
                var code  = str.charCodeAt(i);
                hash  = (hash * 31 + code) | 0;
            }
            return hash;
        }
        
        return (obj) => {
            if (obj == null) {
                return 0;
            }
            switch (typeof obj) {
                case "object":
                case "function":
                    return getObjectHashCode(obj);
                case "number":
                    return numberHashCode(obj);
                case "boolean":
                    return obj ? 1231 : 1237;
                default:
                    return getStringHashCode(String(obj)); 
            }
        }
        })(),
        'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
        'kotlin.wasm.internal.intToExternref' : (x) => x,
        'kotlin.wasm.internal.getJsTrue' : () => true,
        'kotlin.wasm.internal.getJsFalse' : () => false,
        'kotlin.wasm.internal.newJsArray' : () => [],
        'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
        'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
        'kotlin.js.jsCatch' : (f) => { 
            let result = null;
            try { 
                f();
            } catch (e) {
               result = e;
            }
            return result;
             },
        'kotlin.js.__convertKotlinClosureToJsClosure_(()->Unit)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Unit)'](f, )),
        'kotlin.js.jsThrow' : (e) => { throw e; },
        'kotlin.io.printlnImpl' : (message) => console.log(message),
        'kotlin.js.jsArrayGet' : (array, index) => array[index],
        'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
        'kotlin.js.JsArray_$external_fun' : () => new Array(),
        'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
        'kotlin.js.JsBoolean_$external_class_instanceof' : (x) => typeof x === 'boolean',
        'kotlin.js.JsBoolean_$external_class_get' : () => JsBoolean,
        'kotlin.js.stackPlaceHolder_js_code' : () => (''),
        'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
        'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
        'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
        'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
        'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
        'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
        'kotlin.js.JsNumber_$external_class_instanceof' : (x) => typeof x === 'number',
        'kotlin.js.JsNumber_$external_class_get' : () => JsNumber,
        'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
        'kotlin.js.JsString_$external_class_get' : () => JsString,
        'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
        'kotlin.js.__convertKotlinClosureToJsClosure_((Js?)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Js?)'](f, p0)),
        'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
        'kotlin.js.__convertKotlinClosureToJsClosure_((Js)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Js?)'](f, p0)),
        'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
        'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
        'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
        'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
        'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
        'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
        'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
        'kotlin.time.dateNow' : () => Date.now(),
        'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
        'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
        'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
        'kotlinx.coroutines.error_$external_fun' : (_this, p0) => _this.error(p0),
        'kotlinx.coroutines.console_$external_prop_getter' : () => console,
        'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
        'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
        'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
        'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
            const handler = (event) => {
                if (event.source == window && event.data == 'dispatchCoroutine') {
                    event.stopPropagation();
                    process();
                }
            }
            window.addEventListener('message', handler, true);
        },
        'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
        'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
        'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
        'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
        'org.khronos.webgl.getMethodImplForUint8Array' : (obj, index) => obj[index],
        'org.khronos.webgl.getMethodImplForInt8Array' : (obj, index) => obj[index],
        'org.khronos.webgl.Int8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
        'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
        'org.khronos.webgl.slice_$external_fun' : (_this, p0, p1, isDefault0) => _this.slice(p0, isDefault0 ? undefined : p1, ),
        'org.khronos.webgl.ArrayBuffer_$external_class_instanceof' : (x) => x instanceof ArrayBuffer,
        'org.khronos.webgl.ArrayBuffer_$external_class_get' : () => ArrayBuffer,
        'org.khronos.webgl.Uint8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Uint8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
        'org.khronos.webgl.length_$external_prop_getter_1' : (_this) => _this.length,
        'org.khronos.webgl.buffer_$external_prop_getter' : (_this) => _this.buffer,
        'org.khronos.webgl.byteOffset_$external_prop_getter' : (_this) => _this.byteOffset,
        'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
        'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
        'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
        'org.w3c.dom.clipboard.ClipboardEvent_$external_class_get' : () => ClipboardEvent,
        'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
        'org.w3c.dom.css.display_$external_prop_setter' : (_this, v) => _this.display = v,
        'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
        'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
        'org.w3c.dom.css.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
        'org.w3c.dom.css.outline_$external_prop_setter' : (_this, v) => _this.outline = v,
        'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
        'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
        'org.w3c.dom.css.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
        'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
        'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
        'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
        'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
        'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
        'org.w3c.dom.events.stopPropagation_$external_fun' : (_this, ) => _this.stopPropagation(),
        'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
        'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
        'org.w3c.dom.events.Event_$external_class_get' : () => Event,
        'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
        'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
        'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
        'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
        'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
        'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
        'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
        'org.w3c.dom.events.keyCode_$external_prop_getter' : (_this) => _this.keyCode,
        'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
        'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
        'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
        'org.w3c.dom.events.__convertKotlinClosureToJsClosure_((Js)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Unit)'](f, p0)),
        'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
        'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
        'org.w3c.dom.events.addEventListener_$external_fun_3' : (_this, p0, p1) => _this.addEventListener(p0, p1),
        'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1, p2) => _this.removeEventListener(p0, p1, p2),
        'org.w3c.dom.events.removeEventListener_$external_fun_1' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
        'org.w3c.dom.events.removeEventListener_$external_fun_2' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
        'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
        'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
        'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
        'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
        'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
        'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
        'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
        'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
        'org.w3c.dom.events.MouseEvent_$external_class_instanceof' : (x) => x instanceof MouseEvent,
        'org.w3c.dom.events.MouseEvent_$external_class_get' : () => MouseEvent,
        'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
        'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
        'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
        'org.w3c.dom.events.WheelEvent_$external_class_get' : () => WheelEvent,
        'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
        'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
        'org.w3c.dom.events.CompositionEvent_$external_class_get' : () => CompositionEvent,
        'org.w3c.dom.ShadowRootInit' : (mode) => ({ mode: mode }),
        'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
        'org.w3c.dom.getMethodImplForDataTransferItemList' : (obj, index) => obj[index],
        'org.w3c.dom.location_$external_prop_getter' : (_this) => _this.location,
        'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
        'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
        'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
        'org.w3c.dom.__convertKotlinClosureToJsClosure_((Double)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Double)->Unit)'](f, p0)),
        'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
        'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
        'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
        'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
        'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
        'org.w3c.dom.protocol_$external_prop_getter' : (_this) => _this.protocol,
        'org.w3c.dom.tabIndex_$external_prop_setter' : (_this, v) => _this.tabIndex = v,
        'org.w3c.dom.innerText_$external_prop_setter' : (_this, v) => _this.innerText = v,
        'org.w3c.dom.click_$external_fun' : (_this, ) => _this.click(),
        'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
        'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
        'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
        'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
        'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
        'org.w3c.dom.items_$external_prop_getter' : (_this) => _this.items,
        'org.w3c.dom.files_$external_prop_getter' : (_this) => _this.files,
        'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
        'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
        'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
        'org.w3c.dom.protocol_$external_prop_getter_1' : (_this) => _this.protocol,
        'org.w3c.dom.binaryType_$external_prop_setter' : (_this, v) => _this.binaryType = v,
        'org.w3c.dom.close_$external_fun' : (_this, p0, p1, isDefault0, isDefault1) => _this.close(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
        'org.w3c.dom.send_$external_fun' : (_this, p0) => _this.send(p0),
        'org.w3c.dom.send_$external_fun_1' : (_this, p0) => _this.send(p0),
        'org.w3c.dom.Companion_$external_object_getInstance' : () => ({}),
        'org.w3c.dom.data_$external_prop_getter' : (_this) => _this.data,
        'org.w3c.dom.code_$external_prop_getter' : (_this) => _this.code,
        'org.w3c.dom.reason_$external_prop_getter' : (_this) => _this.reason,
        'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
        'org.w3c.dom.onchange_$external_prop_setter' : (_this, v) => _this.onchange = v,
        'org.w3c.dom.caches_$external_prop_getter' : (_this) => _this.caches,
        'org.w3c.dom.setTimeout_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1) => _this.setTimeout(p0, isDefault0 ? undefined : p1, ...p2, ),
        'org.w3c.dom.__convertKotlinClosureToJsClosure_(()->Js?)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Js?)'](f, )),
        'org.w3c.dom.clearTimeout_$external_fun' : (_this, p0, isDefault0) => _this.clearTimeout(isDefault0 ? undefined : p0, ),
        'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
        'org.w3c.dom.documentElement_$external_prop_getter' : (_this) => _this.documentElement,
        'org.w3c.dom.readyState_$external_prop_getter' : (_this) => _this.readyState,
        'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
        'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
        'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
        'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
        'org.w3c.dom.getElementById_$external_fun' : (_this, p0) => _this.getElementById(p0),
        'org.w3c.dom.namespaceURI_$external_prop_getter' : (_this) => _this.namespaceURI,
        'org.w3c.dom.localName_$external_prop_getter' : (_this) => _this.localName,
        'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
        'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
        'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
        'org.w3c.dom.getAttribute_$external_fun' : (_this, p0) => _this.getAttribute(p0),
        'org.w3c.dom.getAttributeNS_$external_fun' : (_this, p0, p1) => _this.getAttributeNS(p0, p1),
        'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
        'org.w3c.dom.attachShadow_$external_fun' : (_this, p0) => _this.attachShadow(p0),
        'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
        'org.w3c.dom.Element_$external_class_instanceof' : (x) => x instanceof Element,
        'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
        'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
        'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
        'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
        'org.w3c.dom.getItem_$external_fun' : (_this, p0) => _this.getItem(p0),
        'org.w3c.dom.setItem_$external_fun' : (_this, p0, p1) => _this.setItem(p0, p1),
        'org.w3c.dom.nodeName_$external_prop_getter' : (_this) => _this.nodeName,
        'org.w3c.dom.isConnected_$external_prop_getter' : (_this) => _this.isConnected,
        'org.w3c.dom.childNodes_$external_prop_getter' : (_this) => _this.childNodes,
        'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
        'org.w3c.dom.lookupPrefix_$external_fun' : (_this, p0) => _this.lookupPrefix(p0),
        'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
        'org.w3c.dom.removeChild_$external_fun' : (_this, p0) => _this.removeChild(p0),
        'org.w3c.dom.Node_$external_class_instanceof' : (x) => x instanceof Node,
        'org.w3c.dom.Node_$external_class_get' : () => Node,
        'org.w3c.dom.Companion_$external_object_getInstance_1' : () => ({}),
        'org.w3c.dom.append_$external_fun' : (_this, p0) => _this.append(...p0),
        'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
        'org.w3c.dom.identifier_$external_prop_getter' : (_this) => _this.identifier,
        'org.w3c.dom.clientX_$external_prop_getter' : (_this) => _this.clientX,
        'org.w3c.dom.clientY_$external_prop_getter' : (_this) => _this.clientY,
        'org.w3c.dom.Touch_$external_class_instanceof' : (x) => x instanceof Touch,
        'org.w3c.dom.Touch_$external_class_get' : () => Touch,
        'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
        'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
        'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
        'org.w3c.dom.kind_$external_prop_getter' : (_this) => _this.kind,
        'org.w3c.dom.type_$external_prop_getter' : (_this) => _this.type,
        'org.w3c.dom.getAsFile_$external_fun' : (_this, ) => _this.getAsFile(),
        'org.w3c.dom.Companion_$external_object_getInstance_2' : () => ({}),
        'org.w3c.dom.download_$external_prop_setter' : (_this, v) => _this.download = v,
        'org.w3c.dom.HTMLAnchorElement_$external_class_instanceof' : (x) => x instanceof HTMLAnchorElement,
        'org.w3c.dom.HTMLAnchorElement_$external_class_get' : () => HTMLAnchorElement,
        'org.w3c.dom.accept_$external_prop_setter' : (_this, v) => _this.accept = v,
        'org.w3c.dom.files_$external_prop_getter_1' : (_this) => _this.files,
        'org.w3c.dom.type_$external_prop_setter' : (_this, v) => _this.type = v,
        'org.w3c.dom.HTMLInputElement_$external_class_instanceof' : (x) => x instanceof HTMLInputElement,
        'org.w3c.dom.HTMLInputElement_$external_class_get' : () => HTMLInputElement,
        'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
        'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
        'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
        'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
        'org.w3c.dom.HTMLDivElement_$external_class_instanceof' : (x) => x instanceof HTMLDivElement,
        'org.w3c.dom.HTMLDivElement_$external_class_get' : () => HTMLDivElement,
        'org.w3c.dom.HTMLTextAreaElement_$external_class_instanceof' : (x) => x instanceof HTMLTextAreaElement,
        'org.w3c.dom.HTMLTextAreaElement_$external_class_get' : () => HTMLTextAreaElement,
        'org.w3c.dom.targetTouches_$external_prop_getter' : (_this) => _this.targetTouches,
        'org.w3c.dom.changedTouches_$external_prop_getter' : (_this) => _this.changedTouches,
        'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
        'org.w3c.dom.TouchEvent_$external_class_get' : () => TouchEvent,
        'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
        'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
        'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
        'org.w3c.dom.href_$external_prop_setter' : (_this, v) => _this.href = v,
        'org.w3c.dom.parsing.DOMParser_$external_fun' : () => new DOMParser(),
        'org.w3c.dom.parsing.parseFromString_$external_fun' : (_this, p0, p1) => _this.parseFromString(p0, p1),
        'org.w3c.dom.url.createObjectURL_$external_fun' : (_this, p0) => _this.createObjectURL(p0),
        'org.w3c.dom.url.revokeObjectURL_$external_fun' : (_this, p0) => _this.revokeObjectURL(p0),
        'org.w3c.dom.url.Companion_$external_object_getInstance' : () => URL,
        'org.w3c.fetch.status_$external_prop_getter' : (_this) => _this.status,
        'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
        'org.w3c.fetch.statusText_$external_prop_getter' : (_this) => _this.statusText,
        'org.w3c.fetch.headers_$external_prop_getter' : (_this) => _this.headers,
        'org.w3c.fetch.body_$external_prop_getter' : (_this) => _this.body,
        'org.w3c.fetch.clone_$external_fun' : (_this, ) => _this.clone(),
        'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
        'org.w3c.fetch.get_$external_fun' : (_this, p0) => _this.get(p0),
        'org.w3c.fetch.Companion_$external_object_getInstance' : () => ({}),
        'org.w3c.files.BlobPropertyBag_js_code' : (type) => ({ type: type }),
        'org.w3c.files.getMethodImplForFileList' : (obj, index) => obj[index],
        'org.w3c.files.Blob_$external_fun' : (p0, p1, isDefault0, isDefault1) => new Blob(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
        'org.w3c.files.type_$external_prop_getter' : (_this) => _this.type,
        'org.w3c.files.name_$external_prop_getter' : (_this) => _this.name,
        'org.w3c.files.FileReader_$external_fun' : () => new FileReader(),
        'org.w3c.files.readyState_$external_prop_getter' : (_this) => _this.readyState,
        'org.w3c.files.result_$external_prop_getter' : (_this) => _this.result,
        'org.w3c.files.error_$external_prop_getter' : (_this) => _this.error,
        'org.w3c.files.__callJsClosure_((Js)->Unit)' : (f, p0) => f(p0),
        'org.w3c.files.onload_$external_prop_getter' : (_this) => _this.onload,
        'org.w3c.files.onload_$external_prop_setter' : (_this, v) => _this.onload = v,
        'org.w3c.files.onerror_$external_prop_setter' : (_this, v) => _this.onerror = v,
        'org.w3c.files.readAsArrayBuffer_$external_fun' : (_this, p0) => _this.readAsArrayBuffer(p0),
        'org.w3c.files.abort_$external_fun' : (_this, ) => _this.abort(),
        'org.w3c.files.LOADING_$external_prop_getter' : (_this) => _this.LOADING,
        'org.w3c.files.Companion_$external_object_getInstance' : () => FileReader,
        'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
        'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
        'org.w3c.workers.CacheQueryOptions_js_code' : (ignoreSearch, ignoreMethod, ignoreVary, cacheName) => ({ ignoreSearch: ignoreSearch, ignoreMethod: ignoreMethod, ignoreVary: ignoreVary, cacheName: cacheName }),
        'org.w3c.workers.match_$external_fun' : (_this, p0, p1, isDefault0) => _this.match(p0, isDefault0 ? undefined : p1, ),
        'org.w3c.workers.put_$external_fun' : (_this, p0, p1) => _this.put(p0, p1),
        'org.w3c.workers.open_$external_fun' : (_this, p0) => _this.open(p0),
        'org.w3c.workers.delete_$external_fun' : (_this, p0) => _this.delete(p0),
        'org.w3c.xhr.XMLHttpRequest_$external_fun' : () => new XMLHttpRequest(),
        'org.w3c.xhr.status_$external_prop_getter' : (_this) => _this.status,
        'org.w3c.xhr.responseType_$external_prop_setter' : (_this, v) => _this.responseType = v,
        'org.w3c.xhr.response_$external_prop_getter' : (_this) => _this.response,
        'org.w3c.xhr.open_$external_fun' : (_this, p0, p1) => _this.open(p0, p1),
        'org.w3c.xhr.open_$external_fun_1' : (_this, p0, p1, p2, p3, p4, isDefault0, isDefault1) => _this.open(p0, p1, p2, isDefault0 ? undefined : p3, isDefault1 ? undefined : p4, ),
        'org.w3c.xhr.send_$external_fun' : (_this, ) => _this.send(),
        'org.w3c.xhr.overrideMimeType_$external_fun' : (_this, p0) => _this.overrideMimeType(p0),
        'org.w3c.xhr.ProgressEvent_$external_class_instanceof' : (x) => x instanceof ProgressEvent,
        'org.w3c.xhr.ProgressEvent_$external_class_get' : () => ProgressEvent,
        'org.w3c.xhr.onerror_$external_prop_setter' : (_this, v) => _this.onerror = v,
        'org.w3c.xhr.onload_$external_prop_setter' : (_this, v) => _this.onload = v,
        'org.w3c.xhr.Companion_$external_object_getInstance' : () => ({}),
        'kotlinx.browser.window_$external_prop_getter' : () => window,
        'kotlinx.browser.document_$external_prop_getter' : () => document,
        'kotlinx.browser.localStorage_$external_prop_getter' : () => localStorage,
        'org.w3c.dom.length_$external_prop_getter_1' : (_this) => _this.length,
        'org.w3c.dom.item_$external_fun_1' : (_this, p0) => _this.item(p0),
        'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
        'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
        'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
        'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
        'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
        'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
        'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
            return {
                alpha: 1,
                depth: 1,
                stencil: 8,
                antialias: 0,
                premultipliedAlpha: 1,
                preserveDrawingBuffer: 0,
                preferLowPowerToHighPerformance: 0,
                failIfMajorPerformanceCaveat: 0,
                enableExtensionsByDefault: 1,
                explicitSwapControl: 0,
                renderViaOffscreenBackBuffer: 0,
                majorVersion: 2,
            }
        }
        ,
        'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
        'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
        'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
        'org.jetbrains.skiko.w3c.language_$external_prop_getter' : (_this) => _this.language,
        'org.jetbrains.skiko.w3c.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
        'org.jetbrains.skiko.w3c.navigator_$external_prop_getter' : (_this) => _this.navigator,
        'org.jetbrains.skiko.w3c.performance_$external_prop_getter' : (_this) => _this.performance,
        'org.jetbrains.skiko.w3c.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
        'org.jetbrains.skiko.w3c.window_$external_object_getInstance' : () => window,
        'org.jetbrains.skiko.w3c.now_$external_fun' : (_this, ) => _this.now(),
        'org.jetbrains.skiko.w3c.width_$external_prop_getter' : (_this) => _this.width,
        'org.jetbrains.skiko.w3c.height_$external_prop_getter' : (_this) => _this.height,
        'org.jetbrains.skiko.w3c.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
        'org.jetbrains.skiko.w3c.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
        'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
        'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
        'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
        'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
        'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
        'androidx.compose.ui.text.platform.toLocaleLowerCase' : (text, locale) => text.toLocaleLowerCase(locale),
        'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
        'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
        'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
        'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
        'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
        'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
        'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
        'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
        'androidx.compose.ui.platform.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
        'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
        'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
        'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
        'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
        'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
        'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
        'androidx.compose.ui.internal.focusExt' : (element, _preventScroll) => element.focus({ preventScroll: _preventScroll }),
        'androidx.compose.ui.platform.setBackingInputBox' : (container, left, top, width, height) => { 
            container.style.setProperty("--compose-internal-web-backing-input-left", left);
            container.style.setProperty("--compose-internal-web-backing-input-top", top);
            container.style.setProperty("--compose-internal-web-backing-input-width", width);
            container.style.setProperty("--compose-internal-web-backing-input-height", height)
         },
        'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
        'androidx.compose.ui.platform.value_$external_prop_setter' : (_this, v) => _this.value = v,
        'androidx.compose.ui.platform.selectionStart_$external_prop_getter' : (_this) => _this.selectionStart,
        'androidx.compose.ui.platform.selectionEnd_$external_prop_getter' : (_this) => _this.selectionEnd,
        'androidx.compose.ui.platform.setSelectionRange_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setSelectionRange(p0, p1, isDefault0 ? undefined : p2, ),
        'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
        'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
        'androidx.compose.ui.platform.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
        'androidx.compose.ui.platform.textRangeStart_$external_prop_getter' : (_this) => _this.textRangeStart,
        'androidx.compose.ui.platform.textRangeStart_$external_prop_setter' : (_this, v) => _this.textRangeStart = v,
        'androidx.compose.ui.platform.textRangeEnd_$external_prop_getter' : (_this) => _this.textRangeEnd,
        'androidx.compose.ui.platform.textRangeEnd_$external_prop_setter' : (_this, v) => _this.textRangeEnd = v,
        'androidx.compose.ui.platform.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
        'androidx.compose.ui.platform.InputEvent_$external_class_get' : () => InputEvent,
        'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
        'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
                window.navigator.clipboard && 
                window.navigator.clipboard.write && 
                window.navigator.clipboard.read && 
                typeof(ClipboardItem) !== 'undefined'
                )
            ,
        'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
        'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
        'androidx.compose.ui.platform.accessibility.removeAllChildrenOf' : (element) => { element.replaceChildren() },
        'androidx.compose.ui.platform.accessibility.setA11YAriaRole' : (element, ariaRoleId) => { 
                var roleValue = "";
                switch (ariaRoleId) {
                    case 0: // Role.Button
                        roleValue = "button";
                        break;
                    case 1: // Role.Checkbox
                        roleValue = "checkbox";
                        break;
                    case 2: // Role.Switch
                        roleValue = "switch";
                        break;
                    case 3: // Role.RadioButton
                        roleValue = "radio";
                        break;
                    case 4: // Role.Tab
                        roleValue = "tab";
                        break;
                    case 5: // Role.Image
                        roleValue = "img";
                        break;
                    case 6: // Role.DropdownList
                        roleValue = "menu";
                        break;
                    case 7: // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
                        roleValue = "heading";
                        break;
                    case 8: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
                        roleValue = "textbox";
                        break;
                    case 9: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
                        roleValue = "list";
                        break;
                    case 10: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
                        roleValue = "grid";
                        break;
                    default:
                        break;
                }
                if (roleValue.length > 0) { 
                    element.setAttribute("role", roleValue);
                } else {
                    element.removeAttribute("role");
                }
             },
        'androidx.compose.ui.platform.accessibility.setSizeAndPosition' : (element, left, top, width, height) => { 
               element.style.left = "" + left + "px";
               element.style.top = "" + top + "px";
               element.style.width = "" + width + "px";
               element.style.height = "" + height + "px";
             },
        'androidx.compose.ui.window.documentIsVisible' : () => document.visibilityState === 'visible',
        'androidx.compose.ui.window.force_$external_prop_getter' : (_this) => _this.force,
        'androidx.compose.foundation.internal.isClipboardWriteSupported' : () => Boolean(window.navigator.clipboard && (window.navigator.clipboard.write || window.navigator.clipboard.writeText)),
        'androidx.compose.foundation.internal.isClipboardReadSupported' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.read),
        'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
        'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
        'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
        'kotlinx.datetime.internal.Date_$external_fun' : (p0) => new Date(p0),
        'kotlinx.datetime.internal.getTimezoneOffset_$external_fun' : (_this, ) => _this.getTimezoneOffset(),
        'kotlinx.datetime.internal.JSJoda.ZoneRulesProvider_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneRulesProvider,
        'kotlinx.datetime.internal.JSJoda.id_$external_fun' : (_this, ) => _this.id(),
        'kotlinx.datetime.internal.JSJoda.systemDefault_$external_fun' : (_this, ) => _this.systemDefault(),
        'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneId,
        'kotlinx.datetime.internal.withCaughtJsException' : (body) => {
            try {
                body();
                return null;
            } catch(e) {
                return e;
            }
        },
        'kotlinx.datetime.internal.getExceptionMessage' : (jsException) => jsException.message,
        'kotlinx.datetime.internal.getZones' : (rulesProvider) => rulesProvider.getTzdbData().zones,
        'kotlinx.datetime.internal.getLinks' : (rulesProvider) => rulesProvider.getTzdbData().links,
        'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
        'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
        'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
        'org.jetbrains.compose.resources.isInTestEnvironment' : () => window.composeResourcesTesting == true,
        'org.jetbrains.compose.resources.requestResponseAsByteArray' : (req) =>  {
                var text = req.responseText;
                var int8Arr = new Int8Array(text.length);
                for (var i = 0; i < text.length; i++) {
                    int8Arr[i] = text.charCodeAt(i) & 0xFF;
                }
                return int8Arr;
            },
        'org.jetbrains.compose.resources.jsExportInt8ArrayToWasm' :  (src, size, dstAddr) => {
                const mem8 = new Int8Array(wasmExports.memory.buffer, dstAddr, size);
                mem8.set(src);
            }
        ,
        'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
        'org.jetbrains.compose.resources.supportsCacheApi' : () => Boolean(window.caches),
        'com.kizitonwose.calendar.core.jsFirstDayFromTag' : (languageTag) => new Intl.Locale(languageTag).weekInfo?.firstDay,
        'com.kizitonwose.calendar.data.consoleLog_$external_fun' : (p0) => ((output) => console.log(output))(...p0),
        'coil3.util.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
        'coil3.util.deref_$external_fun' : (_this, ) => _this.deref(),
        'kotlinx.io.node.sep_$external_prop_getter' : (_this) => _this.sep,
        'kotlinx.io.node.requireExists' : () => typeof require === 'function',
        'kotlinx.io.node.requireModule' : (mod) => {
             try {
                 let m = require(mod);
                 if (m) return m;
                 return null;
             } catch (e) {
                 return null;
             }
         },
        'io.ktor.utils.io.js.decode' : (decoder, buffer) => { try { return decoder.decode(buffer) } catch(e) { return null } },
        'io.ktor.utils.io.js.tryCreateTextDecoder' : (encoding, fatal) => { try { return new TextDecoder(encoding, { fatal: fatal }) } catch(e) { return null } },
        'io.ktor.utils.io.charsets.toJsArrayImpl' : (x) => new Int8Array(x),
        'io.ktor.util.hasNodeApi' : () => 
        (typeof process !== 'undefined' 
            && process.versions != null 
            && process.versions.node != null) ||
        (typeof window !== 'undefined' 
            && typeof window.process !== 'undefined' 
            && window.process.versions != null 
            && window.process.versions.node != null)
        ,
        'io.ktor.util.logging.getKtorLogLevel' : () => process.env.KTOR_LOG_LEVEL,
        'io.ktor.util.logging.debug_$external_fun' : (_this, p0) => _this.debug(p0),
        'io.ktor.util.logging.console_$external_prop_getter' : () => console,
        'io.ktor.util.date.Date_$external_fun' : () => new Date(),
        'io.ktor.util.date.Date_$external_fun_1' : (p0) => new Date(p0),
        'io.ktor.util.date.getTime_$external_fun' : (_this, ) => _this.getTime(),
        'io.ktor.util.date.getUTCDate_$external_fun' : (_this, ) => _this.getUTCDate(),
        'io.ktor.util.date.getUTCDay_$external_fun' : (_this, ) => _this.getUTCDay(),
        'io.ktor.util.date.getUTCFullYear_$external_fun' : (_this, ) => _this.getUTCFullYear(),
        'io.ktor.util.date.getUTCHours_$external_fun' : (_this, ) => _this.getUTCHours(),
        'io.ktor.util.date.getUTCMinutes_$external_fun' : (_this, ) => _this.getUTCMinutes(),
        'io.ktor.util.date.getUTCMonth_$external_fun' : (_this, ) => _this.getUTCMonth(),
        'io.ktor.util.date.getUTCSeconds_$external_fun' : (_this, ) => _this.getUTCSeconds(),
        'io.ktor.http.locationOrigin' : () => function() {
            var tmpLocation = null
            if (typeof window !== 'undefined') {
              tmpLocation = window.location
            } else if (typeof self !== 'undefined') {
              tmpLocation = self.location
            }
            var origin = ""
            if (tmpLocation) {
              origin = tmpLocation.origin
            }
            return origin && origin != "null" ? origin : "http://localhost"    
        }(),
        'io.ktor.client.engine.js.createBrowserWebSocket' : (urlString_capturingHack, protocols) => new WebSocket(urlString_capturingHack, protocols),
        'io.ktor.client.engine.js.createWebSocketNodeJs' : (socketCtor, urlString_capturingHack, headers_capturingHack, protocols) => new socketCtor(urlString_capturingHack, protocols, { headers: headers_capturingHack }),
        'io.ktor.client.engine.js.getKeys' : (headers) => Array.from(headers.keys()),
        'io.ktor.client.engine.js.eventAsString' : (event) => JSON.stringify(event, ['message', 'target', 'type', 'isTrusted']),
        'io.ktor.client.engine.js.compatibility.abortControllerCtorBrowser' : () => AbortController,
        'io.ktor.client.fetch.body_$external_prop_setter' : (_this, v) => _this.body = v,
        'io.ktor.client.fetch.headers_$external_prop_setter' : (_this, v) => _this.headers = v,
        'io.ktor.client.fetch.method_$external_prop_setter' : (_this, v) => _this.method = v,
        'io.ktor.client.fetch.redirect_$external_prop_setter' : (_this, v) => _this.redirect = v,
        'io.ktor.client.fetch.signal_$external_prop_setter' : (_this, v) => _this.signal = v,
        'io.ktor.client.fetch.signal_$external_prop_getter' : (_this) => _this.signal,
        'io.ktor.client.fetch.abort_$external_fun' : (_this, ) => _this.abort(),
        'io.ktor.client.fetch.fetch_$external_fun' : (p0, p1, isDefault0) => fetch(p0, isDefault0 ? undefined : p1, ),
        'io.ktor.client.fetch.getReader_$external_fun' : (_this, ) => _this.getReader(),
        'io.ktor.client.fetch.cancel_$external_fun' : (_this, p0, isDefault0) => _this.cancel(isDefault0 ? undefined : p0, ),
        'io.ktor.client.fetch.read_$external_fun' : (_this, ) => _this.read(),
        'io.ktor.client.fetch.done_$external_prop_getter' : (_this) => _this.done,
        'io.ktor.client.fetch.value_$external_prop_getter' : (_this) => _this.value,
        'io.ktor.client.plugins.websocket.tryGetEventDataAsString' : (data) => typeof(data) === 'string' ? data : null,
        'io.ktor.client.plugins.websocket.tryGetEventDataAsArrayBuffer' : (data) => data instanceof ArrayBuffer ? data : null,
        'io.ktor.client.utils.makeJsObject' : () => { return {}; },
        'io.ktor.client.utils.makeImport' : (name) => import(name),
        'io.ktor.client.utils.makeJsCall' : (func, arg) => func.apply(null, arg),
        'io.ktor.client.utils.jsObjectAssign' : () => Object.assign,
        'io.ktor.client.utils.makeJsNew' : (ctor) => new ctor(),
        'io.ktor.client.utils.getObjectField' : (obj, name) => obj[name],
        'io.ktor.client.utils.setObjectField' : (obj, name, value) => obj[name]=value,
        'io.ktor.client.utils.toJsArrayImpl' : (x) => new Uint8Array(x),
        'app.serpwidgets.snakemeasurer.util.jsInitAnalytics' : (enabled) => { if (window.initFirebaseAnalytics) window.initFirebaseAnalytics(enabled); },
        'app.serpwidgets.snakemeasurer.util.jsTrackEvent' : (eventName, category, action, label, paramsJson) => { var p = paramsJson ? JSON.parse(paramsJson) : {}; p.item_category = category; p.method = action; p.item_name = label || ''; if (window.trackFirebaseEvent) window.trackFirebaseEvent(eventName, p); },
        'app.serpwidgets.snakemeasurer.util.jsTrackMeasurement' : (lengthCm, unit, pointCount) => { if (window.trackFirebaseEvent) window.trackFirebaseEvent('snake_measurement', { length_cm: lengthCm, unit: unit, point_count: pointCount }); },
        'app.serpwidgets.snakemeasurer.util.jsFetchFont' : (url, onSuccess, onError) => { fetch(url).then(r => r.arrayBuffer()).then(buf => { const arr = new Int8Array(buf); onSuccess(arr, arr.length); }).catch(e => { onError('' + (e.message || e)); }); },
        'app.serpwidgets.snakemeasurer.util.__convertKotlinClosureToJsClosure_((Js,Int)->Unit)' : (f) => getCachedJsObject(f, (p0, p1) => wasmExports['__callFunction_((Js,Int)->Unit)'](f, p0, p1)),
        'app.serpwidgets.snakemeasurer.util.jsGetByte' : (arr, i) => arr[i],
        'app.serpwidgets.snakemeasurer.util.jsSentryBreadcrumb' : (tag, message) => { if (typeof Sentry !== 'undefined') Sentry.addBreadcrumb({category: tag, message: message, level: 'info'}); },
        'app.serpwidgets.snakemeasurer.util.jsSentryCaptureException' : (msg) => { if (typeof Sentry !== 'undefined') Sentry.captureException(new Error(msg)); },
        'app.serpwidgets.snakemeasurer.util.jsSentryCaptureWarning' : (tag, msg) => { if (typeof Sentry !== 'undefined') Sentry.captureMessage('[' + tag + '] ' + msg, 'warning'); },
        'app.serpwidgets.snakemeasurer.util.jsHasCurrentUser' : () => { return window.currentFirebaseUser ? true : false; },
        'app.serpwidgets.snakemeasurer.util.jsGetUserUid' : () => { var u = window.currentFirebaseUser; return u ? (u.uid || '') : ''; },
        'app.serpwidgets.snakemeasurer.util.jsGetUserEmail' : () => { var u = window.currentFirebaseUser; return u ? (u.email || '') : ''; },
        'app.serpwidgets.snakemeasurer.util.jsGetUserDisplayName' : () => { var u = window.currentFirebaseUser; return u ? (u.displayName || '') : ''; },
        'app.serpwidgets.snakemeasurer.util.jsGetUserPhotoUrl' : () => { var u = window.currentFirebaseUser; return u ? (u.photoURL || '') : ''; },
        'app.serpwidgets.snakemeasurer.util.jsGetUserProvider' : 
        () => {
            var u = window.currentFirebaseUser;
            if (!u || !u.providerData) return 'password';
            for (var i = 0; i < u.providerData.length; i++) {
                var pid = u.providerData[i].providerId;
                if (pid === 'google.com') return 'google.com';
                if (pid === 'apple.com') return 'apple.com';
                if (pid === 'facebook.com') return 'facebook.com';
            }
            return 'password';
        }
        ,
        'app.serpwidgets.snakemeasurer.util.jsSignInWithGoogle' : 
        (onSuccess, onError) => {
            function run() {
                try {
                    var done = false;
                    var provider = new firebase.auth.GoogleAuthProvider();
                    window.firebaseAuth.signInWithPopup(provider).then(function(result) {
                        if (done) return; done = true;
                        var u = result && result.user ? result.user : result;
                        if (!u || !u.uid) { onError('Failed to get user'); return; }
                        var pid = 'password';
                        if (u.providerData) { for (var i = 0; i < u.providerData.length; i++) { var p = u.providerData[i].providerId; if (p === 'google.com' || p === 'apple.com' || p === 'facebook.com') { pid = p; break; } } }
                        onSuccess(u.uid || '', u.email || '', u.displayName || '', u.photoURL || '', pid);
                    }).catch(function(e) { if (done) return; done = true; onError(e.message || 'Google sign in failed'); });
                } catch(e) { onError(e.message || 'Google sign in failed'); }
            }
            if (window.firebaseAuth) { run(); }
            else if (window._firebaseReadyPromise) { window._firebaseReadyPromise.then(run); }
            else { onError('Firebase not available'); }
        }
        ,
        'app.serpwidgets.snakemeasurer.util.__convertKotlinClosureToJsClosure_((Js,Js,Js,Js,Js)->Unit)' : (f) => getCachedJsObject(f, (p0, p1, p2, p3, p4) => wasmExports['__callFunction_((Js,Js,Js,Js,Js)->Unit)'](f, p0, p1, p2, p3, p4)),
        'app.serpwidgets.snakemeasurer.util.jsSignInWithApple' : 
        (onSuccess, onError) => {
            function run() {
                try {
                    var provider = new firebase.auth.OAuthProvider('apple.com');
                    provider.addScope('email');
                    provider.addScope('name');
                    window.firebaseAuth.signInWithPopup(provider).then(function(result) {
                        var u = result && result.user ? result.user : result;
                        if (!u || !u.uid) { onError('Failed to get user'); return; }
                        var pid = 'password';
                        if (u.providerData) { for (var i = 0; i < u.providerData.length; i++) { var p = u.providerData[i].providerId; if (p === 'google.com' || p === 'apple.com' || p === 'facebook.com') { pid = p; break; } } }
                        onSuccess(u.uid || '', u.email || '', u.displayName || '', u.photoURL || '', pid);
                    }).catch(function(e) { onError(e.message || 'Apple sign in failed'); });
                } catch(e) { onError(e.message || 'Apple sign in failed'); }
            }
            if (window.firebaseAuth) { run(); }
            else if (window._firebaseReadyPromise) { window._firebaseReadyPromise.then(run); }
            else { onError('Firebase not available'); }
        }
        ,
        'app.serpwidgets.snakemeasurer.util.jsSignInWithFacebook' : 
        (onSuccess, onError) => {
            function run() {
                try {
                    var provider = new firebase.auth.FacebookAuthProvider();
                    provider.addScope('email');
                    window.firebaseAuth.signInWithPopup(provider).then(function(result) {
                        var u = result && result.user ? result.user : result;
                        if (!u || !u.uid) { onError('Failed to get user'); return; }
                        var pid = 'password';
                        if (u.providerData) { for (var i = 0; i < u.providerData.length; i++) { var p = u.providerData[i].providerId; if (p === 'google.com' || p === 'apple.com' || p === 'facebook.com') { pid = p; break; } } }
                        onSuccess(u.uid || '', u.email || '', u.displayName || '', u.photoURL || '', pid);
                    }).catch(function(e) { onError(e.message || 'Facebook sign in failed'); });
                } catch(e) { onError(e.message || 'Facebook sign in failed'); }
            }
            if (window.firebaseAuth) { run(); }
            else if (window._firebaseReadyPromise) { window._firebaseReadyPromise.then(run); }
            else { onError('Firebase not available'); }
        }
        ,
        'app.serpwidgets.snakemeasurer.util.jsSignInWithEmail' : 
        (email, password, onSuccess, onError) => {
            function run() {
                try {
                    window.firebaseAuth.signInWithEmailAndPassword(email, password).then(function(result) {
                        var u = result && result.user ? result.user : result;
                        if (!u || !u.uid) { onError('Failed to get user'); return; }
                        onSuccess(u.uid || '', u.email || '', u.displayName || '', u.photoURL || '', 'password');
                    }).catch(function(e) { onError(e.message || 'Email sign in failed'); });
                } catch(e) { onError(e.message || 'Email sign in failed'); }
            }
            if (window.firebaseAuth) { run(); }
            else if (window._firebaseReadyPromise) { window._firebaseReadyPromise.then(run); }
            else { onError('Firebase not available'); }
        }
        ,
        'app.serpwidgets.snakemeasurer.util.jsCreateAccountWithEmail' : 
        (email, password, onSuccess, onError) => {
            function run() {
                try {
                    window.firebaseAuth.createUserWithEmailAndPassword(email, password).then(function(result) {
                        var u = result && result.user ? result.user : result;
                        if (!u || !u.uid) { onError('Failed to create user'); return; }
                        onSuccess(u.uid || '', u.email || '', u.displayName || '', u.photoURL || '', 'password');
                    }).catch(function(e) { onError(e.message || 'Account creation failed'); });
                } catch(e) { onError(e.message || 'Account creation failed'); }
            }
            if (window.firebaseAuth) { run(); }
            else if (window._firebaseReadyPromise) { window._firebaseReadyPromise.then(run); }
            else { onError('Firebase not available'); }
        }
        ,
        'app.serpwidgets.snakemeasurer.util.jsSendPasswordResetEmail' : 
        (email, onSuccess, onError) => {
            function run() {
                try {
                    window.firebaseAuth.sendPasswordResetEmail(email).then(function() {
                        onSuccess();
                    }).catch(function(e) { onError(e.message || 'Failed to send reset email'); });
                } catch(e) { onError(e.message || 'Failed to send reset email'); }
            }
            if (window.firebaseAuth) { run(); }
            else if (window._firebaseReadyPromise) { window._firebaseReadyPromise.then(run); }
            else { onError('Firebase not available'); }
        }
        ,
        'app.serpwidgets.snakemeasurer.util.jsSignOut' : 
        (onSuccess, onError) => {
            function run() {
                try {
                    window.firebaseAuth.signOut().then(function() {
                        onSuccess();
                    }).catch(function(e) { onError(e.message || 'Sign out failed'); });
                } catch(e) { onError(e.message || 'Sign out failed'); }
            }
            if (window.firebaseAuth) { run(); }
            else if (window._firebaseReadyPromise) { window._firebaseReadyPromise.then(run); }
            else { onError('Firebase not available'); }
        }
        ,
        'app.serpwidgets.snakemeasurer.util.jsGetIdToken' : 
        (onSuccess, onError) => {
            function run() {
                try {
                    var user = window.firebaseAuth.currentUser;
                    if (!user) { onSuccess(''); return; }
                    user.getIdToken().then(function(token) {
                        onSuccess(token || '');
                    }).catch(function(e) { onError(e.message || 'Failed to get token'); });
                } catch(e) { onError(e.message || 'Failed to get token'); }
            }
            if (window.firebaseAuth) { run(); }
            else if (window._firebaseReadyPromise) { window._firebaseReadyPromise.then(run); }
            else { onSuccess(''); }
        }
        ,
        'app.serpwidgets.snakemeasurer.util.jsRegisterAuthStateCallback' : 
        (callback) => {
            window._onAuthStateChangedKotlin = function(user) {
                if (user) {
                    callback(
                        (user.uid || '').toString(),
                        (user.email || '').toString(),
                        (user.displayName || '').toString(),
                        (user.photoURL || '').toString(),
                        (user.providerData && user.providerData[0] ? user.providerData[0].providerId : '').toString()
                    );
                } else {
                    callback('', '', '', '', '');
                }
            };
            // If user is already restored (race condition), fire immediately
            if (window.currentFirebaseUser) {
                window._onAuthStateChangedKotlin(window.currentFirebaseUser);
            }
        }
        ,
        'app.serpwidgets.snakemeasurer.util.isPhoneBrowserJs' : () => /iPad|iPhone|iPod|android/i.test(navigator.userAgent || '') || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1),
        'app.serpwidgets.snakemeasurer.util.wasmBlobFromBase64' : (b64, mimeType) => { const binary = atob(b64); const bytes = new Uint8Array(binary.length); for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i); return new Blob([bytes], { type: mimeType }); },
        'app.serpwidgets.snakemeasurer.util.wasmTryNativeShare' : (filename, mimeType, blob, text, onOutcome) => { try { if (typeof navigator === 'undefined' || typeof navigator.canShare !== 'function') return false; const file = new File([blob], filename, { type: mimeType }); if (!navigator.canShare({ files: [file] })) return false; const data = { files: [file] }; if (text) data.text = text; navigator.share(data).then(() => onOutcome(true)).catch(() => onOutcome(false)); return true; } catch (e) { return false; } },
        'app.serpwidgets.snakemeasurer.util.__convertKotlinClosureToJsClosure_((Boolean)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Boolean)->Unit)'](f, p0)),
        'app.serpwidgets.snakemeasurer.util.jsCheckCameraAvailable' : () => !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia),
        'app.serpwidgets.snakemeasurer.util.jsFileLastModified' : (file) => file.lastModified,
        'app.serpwidgets.snakemeasurer.util.jsBrowserTranscodeToJpeg' : (file, maxSide, cb) => {
          // Exactly one callback whatever the browser does: a second call would report a success as an
          // error (or the reverse) on the Kotlin side.
          let finished = false;
          const done = (ab) => { if (finished) return; finished = true; cb(ab); };
          const draw = (src, w0, h0) => {
            try {
              const scale = Math.min(1, maxSide / Math.max(w0, h0));
              const w = Math.max(1, Math.round(w0 * scale)), h = Math.max(1, Math.round(h0 * scale));
              const c = document.createElement('canvas'); c.width = w; c.height = h;
              c.getContext('2d').drawImage(src, 0, 0, w, h);
              if (src.close) src.close();
              c.toBlob((blob) => {
                // Async callback: the try/catch around draw() does not cover it. Blob.arrayBuffer is
                // missing on Safari < 14 — without this guard the TypeError killed the callback and the
                // picker's spinner never ended (neither onImageSelected nor onError fired).
                try {
                  if (!blob) { done(null); return; }
                  const p = (typeof blob.arrayBuffer === 'function') ? blob.arrayBuffer() : new Response(blob).arrayBuffer();
                  p.then(done, () => done(null));
                } catch (e) { done(null); }
              }, 'image/jpeg', 0.92);
            } catch (e) { done(null); }
          };
          const viaImg = () => {
            const url = URL.createObjectURL(file); const img = new Image();
            img.onload = () => { URL.revokeObjectURL(url); draw(img, img.naturalWidth || img.width, img.naturalHeight || img.height); };
            img.onerror = () => { URL.revokeObjectURL(url); done(null); };
            img.src = url;
          };
          if (typeof createImageBitmap === 'function') {
            createImageBitmap(file, { imageOrientation: 'from-image' })
              .then((bmp) => draw(bmp, bmp.width, bmp.height), viaImg);
          } else viaImg();
        },
        'app.serpwidgets.snakemeasurer.util.__convertKotlinClosureToJsClosure_((Js?)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Unit)'](f, p0)),
        'app.serpwidgets.snakemeasurer.util.jsLocalStorageSet' : (key, value) => { try { localStorage.setItem(key, value); } catch(e) { console.error('localStorage setItem error:', e); } },
        'app.serpwidgets.snakemeasurer.util.jsLocalStorageGet' : (key) => { try { return localStorage.getItem(key); } catch(e) { console.error('localStorage getItem error:', e); return null; } },
        'app.serpwidgets.snakemeasurer.util.jsLocalStorageRemove' : (key) => { try { localStorage.removeItem(key); } catch(e) {} },
        'app.serpwidgets.snakemeasurer.util.jsRequestPersistentStorage' : 
        () => {
            try {
                if (navigator.storage && navigator.storage.persist) {
                    navigator.storage.persist().then(granted => {
                        console.log('Persistent storage granted:', granted);
                    });
                }
            } catch(e) {}
        }
        ,
        'app.serpwidgets.snakemeasurer.util.jsSaveRecordsToIndexedDB' : 
        (dbName, storeName, records) => {
            try {
                const request = indexedDB.open(dbName, 2);
                request.onupgradeneeded = (e) => {
                    const db = e.target.result;
                    if (!db.objectStoreNames.contains('history')) {
                        db.createObjectStore('history', { keyPath: 'id' });
                    }
                    if (!db.objectStoreNames.contains('animals')) {
                        db.createObjectStore('animals', { keyPath: 'id' });
                    }
                };
                request.onsuccess = () => {
                    const db = request.result;
                    try {
                        const tx = db.transaction([storeName], 'readwrite');
                        const store = tx.objectStore(storeName);
                        store.clear();
                        const parsed = JSON.parse(records);
                        for (const rec of parsed) {
                            store.put(rec);
                        }
                        tx.oncomplete = () => {
                            console.log('IndexedDB saved', parsed.length, 'records to', storeName);
                        };
                    } catch(e) {
                        console.error('IndexedDB transaction error:', e);
                    }
                };
                request.onerror = () => {
                    console.error('IndexedDB open error');
                };
            } catch(e) {
                console.error('IndexedDB save error:', e);
            }
        }
        ,
        'app.serpwidgets.snakemeasurer.util.jsLoadRecordsFromIndexedDB' : 
        (dbName, storeName, blobKey, dataCallback, blobCallback, doneCallback) => {
            try {
                const request = indexedDB.open(dbName, 2);
                request.onupgradeneeded = (e) => {
                    const db = e.target.result;
                    if (!db.objectStoreNames.contains('history')) {
                        db.createObjectStore('history', { keyPath: 'id' });
                    }
                    if (!db.objectStoreNames.contains('animals')) {
                        db.createObjectStore('animals', { keyPath: 'id' });
                    }
                };
                request.onsuccess = () => {
                    const db = request.result;
                    try {
                        const tx = db.transaction([storeName], 'readonly');
                        const store = tx.objectStore(storeName);
                        const blobReq = store.get(blobKey);
                        blobReq.onsuccess = () => {
                            if (blobReq.result && blobReq.result.data) {
                                blobCallback(blobReq.result.data);
                                doneCallback();
                            } else {
                                const allReq = store.getAll();
                                allReq.onsuccess = () => {
                                    const results = allReq.result || [];
                                    for (let i = 0; i < results.length; i++) {
                                        if (results[i].data) {
                                            dataCallback(results[i].data);
                                        }
                                    }
                                    doneCallback();
                                };
                                allReq.onerror = () => { doneCallback(); };
                            }
                        };
                        blobReq.onerror = () => { doneCallback(); };
                    } catch(e) {
                        console.error('IndexedDB read transaction error:', e);
                        doneCallback();
                    }
                };
                request.onerror = () => { doneCallback(); };
            } catch(e) {
                console.error('IndexedDB load error:', e);
                doneCallback();
            }
        }
        ,
        'app.serpwidgets.snakemeasurer.util.__convertKotlinClosureToJsClosure_((String)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((String)->Unit)'](f, p0)),
        'app.serpwidgets.snakemeasurer.util.jsDeleteFromIndexedDB' : 
        (dbName, storeName, key) => {
            try {
                const request = indexedDB.open(dbName, 2);
                request.onsuccess = () => {
                    const db = request.result;
                    try {
                        const tx = db.transaction([storeName], 'readwrite');
                        const store = tx.objectStore(storeName);
                        store.delete(key);
                    } catch(e) {}
                };
            } catch(e) {}
        }
        ,
        'app.serpwidgets.snakemeasurer.util.jsClearStores' : 
        (dbName, storeNames) => {
            try {
                const request = indexedDB.open(dbName, 2);
                request.onsuccess = () => {
                    const db = request.result;
                    const names = JSON.parse(storeNames);
                    try {
                        const tx = db.transaction(names, 'readwrite');
                        for (const name of names) {
                            tx.objectStore(name).clear();
                        }
                    } catch(e) { console.error('Clear stores error:', e); }
                };
            } catch(e) {}
        }
        ,
        'app.serpwidgets.snakemeasurer.util.dateNow' : () => Date.now(),
        'app.serpwidgets.snakemeasurer.util.getNavigatorLanguage' : () => navigator.language || navigator.userLanguage || 'en',
        'app.serpwidgets.snakemeasurer.util.windowOpen' : (url) => window.open(url, '_blank'),
        'app.serpwidgets.snakemeasurer.util.callHideLoader' : () => window._hideLoader && window._hideLoader(),
        'app.serpwidgets.snakemeasurer.util.checkIsTelegram' : () => !!(window._isTelegram),
        'app.serpwidgets.snakemeasurer.util.checkNavigatorOnLine' : () => navigator.onLine,
        'app.serpwidgets.snakemeasurer.util.checkPrefersReducedMotion' : () => !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches),
        'app.serpwidgets.snakemeasurer.util.jsRcConfigure' : (userId) => { return window.rcConfigure(userId || null) ? true : false; },
        'app.serpwidgets.snakemeasurer.util.jsRcCheckStatus' : 
        (onSuccess, onError) => {
            if (!window._rcInstance) { onError('RC not configured'); return; }
            window.rcGetCustomerInfo().then(function(ci) {
                var isPremium = window.rcCheckEntitlement(ci, 'premium');
                var productId = window.rcGetProductId(ci, 'premium');
                var expMs = window.rcGetExpiration(ci, 'premium');
                onSuccess(isPremium, productId, expMs);
            }).catch(function(e) { onError(e.message || 'Failed to check status'); });
        }
        ,
        'app.serpwidgets.snakemeasurer.util.__convertKotlinClosureToJsClosure_((Js,Js,Js)->Unit)' : (f) => getCachedJsObject(f, (p0, p1, p2) => wasmExports['__callFunction_((Js,Js,Js)->Unit)'](f, p0, p1, p2)),
        'app.serpwidgets.snakemeasurer.util.jsRcRestore' : 
        (onSuccess, onError) => {
            if (!window._rcInstance) { onError('RC not configured'); return; }
            window.rcRestorePurchases().then(function(ci) {
                var isPremium = window.rcCheckEntitlement(ci, 'premium');
                var productId = window.rcGetProductId(ci, 'premium');
                var expMs = window.rcGetExpiration(ci, 'premium');
                onSuccess(isPremium, productId, expMs);
            }).catch(function(e) { onError(e.message || 'Restore failed'); });
        }
        ,
        'app.serpwidgets.snakemeasurer.util.jsRcLogIn' : 
        (userId, onSuccess, onError) => {
            if (!window._rcInstance) { onError('RC not configured'); return; }
            window.rcLogIn(userId).then(function(result) {
                var ci = result.customerInfo;
                var isPremium = window.rcCheckEntitlement(ci, 'premium');
                var productId = window.rcGetProductId(ci, 'premium');
                var expMs = window.rcGetExpiration(ci, 'premium');
                onSuccess(isPremium, productId, expMs);
            }).catch(function(e) { onError(e.message || 'Login failed'); });
        }
        ,
        'app.serpwidgets.snakemeasurer.util.jsRcLogOut' : 
        (onSuccess, onError) => {
            if (!window._rcInstance) { onSuccess(); return; }
            window.rcLogOut().then(function() { onSuccess(); }).catch(function() { onSuccess(); });
        }
        ,
        'app.serpwidgets.snakemeasurer.util.jsTelegramLogin' : 
        (botUsername, title, cancelLabel, appLink, appLabel, onResult) => {
            if (typeof window.telegramLogin !== 'function') { onResult('!load'); return; }
            try {
                window.telegramLogin(botUsername, title, cancelLabel, appLink || null, appLabel || null,
                    function (raw) { onResult(raw || ''); });
            } catch (e) { onResult('!load'); }
        }
        ,
        'app.serpwidgets.snakemeasurer.util.jsTelegramLoginClose' : () => { if (typeof window.telegramLoginClose === 'function') window.telegramLoginClose(); },
        'app.serpwidgets.snakemeasurer.util.jsSignInWithCustomToken' : 
        (token, onSuccess, onError) => {
            function run() {
                try {
                    window.firebaseAuth.signInWithCustomToken(token).then(function(result) {
                        var u = result && result.user ? result.user : result;
                        if (!u || !u.uid) { onError('Failed to get user'); return; }
                        onSuccess(u.uid || '', u.email || '', u.displayName || '', u.photoURL || '');
                    }).catch(function(e) { onError(e.message || 'Telegram sign in failed'); });
                } catch(e) { onError(e.message || 'Telegram sign in failed'); }
            }
            if (window.firebaseAuth) { run(); }
            else if (window._firebaseReadyPromise) { window._firebaseReadyPromise.then(run); }
            else { onError('Firebase not available'); }
        }
        ,
        'app.serpwidgets.snakemeasurer.util.__convertKotlinClosureToJsClosure_((Js,Js,Js,Js)->Unit)' : (f) => getCachedJsObject(f, (p0, p1, p2, p3) => wasmExports['__callFunction_((Js,Js,Js,Js)->Unit)'](f, p0, p1, p2, p3)),
        'app.serpwidgets.snakemeasurer.util.tonPayJs' : (address, amountNano) => window.tonConnectPay ? (window.tonConnectPay(address, amountNano), true) : false,
        'app.serpwidgets.snakemeasurer.util.reloadJs' : () => window.location.reload(),
        'app.serpwidgets.snakemeasurer.util.jsShowNativeLoginForm' : 
        (isCreate, isDark) => {
            if (typeof window.showNativeLoginForm === 'function') {
                window.showNativeLoginForm(isCreate ? 'create' : 'signin', isDark);
            }
        }
        ,
        'app.serpwidgets.snakemeasurer.util.jsHideNativeLoginForm' : () => { if (typeof window.hideNativeLoginForm === 'function') { window.hideNativeLoginForm(); } },
        'app.serpwidgets.snakemeasurer.util.jsShowNativeLoginError' : (msg) => { if (typeof window.showNativeLoginError === 'function') { window.showNativeLoginError(msg); } },
        'app.serpwidgets.snakemeasurer.util.jsHideNativeLoginError' : () => { if (typeof window.hideNativeLoginError === 'function') { window.hideNativeLoginError(); } },
        'app.serpwidgets.snakemeasurer.util.jsSetLoginCallbacks' : 
        (onSubmit, onCreateAccount, onForgotPassword, onDismiss) => {
            window._nativeLoginOnSubmit = function(email, password) { onSubmit(email, password); };
            window._nativeLoginOnCreateAccount = function(email, password) { onCreateAccount(email, password); };
            window._nativeLoginOnForgotPassword = function(email) { onForgotPassword(email); };
            window._nativeLoginOnDismiss = function() { onDismiss(); };
        }
        ,
        'app.serpwidgets.snakemeasurer.util.__convertKotlinClosureToJsClosure_((Js,Js)->Unit)' : (f) => getCachedJsObject(f, (p0, p1) => wasmExports['__callFunction_((Js,Js)->Unit)'](f, p0, p1))
    }
    
    // Placed here to give access to it from externals (js_code)
    let wasmInstance;
    let require; 
    let wasmExports;

    const isNodeJs = (typeof process !== 'undefined') && (process.release.name === 'node');
    const isDeno = !isNodeJs && (typeof Deno !== 'undefined')
    const isStandaloneJsVM =
        !isDeno && !isNodeJs && (
            typeof d8 !== 'undefined' // V8
            || typeof inIon !== 'undefined' // SpiderMonkey
            || typeof jscOptions !== 'undefined' // JavaScriptCore
        );
    const isBrowser = !isNodeJs && !isDeno && !isStandaloneJsVM && (typeof window !== 'undefined' || typeof self !== 'undefined');
    
    if (!isNodeJs && !isDeno && !isStandaloneJsVM && !isBrowser) {
      throw "Supported JS engine not detected";
    }

    const wasmFilePath = './SnakeMeasurer-composeApp.wasm';

    const importObject = {
        js_code,
        intrinsics: {
            tag: wasmTag
        },
        './skiko.mjs': imports['./skiko.mjs'],


    };
    
    try {
      if (isNodeJs) {
        const module = await import(/* webpackIgnore: true */'node:module');
        const importMeta = import.meta;
        require = module.default.createRequire(importMeta.url);
        const fs = require('fs');
        const url = require('url');
        const filepath = import.meta.resolve(wasmFilePath);
        const wasmBuffer = fs.readFileSync(url.fileURLToPath(filepath));
        const wasmModule = new WebAssembly.Module(wasmBuffer);
        wasmInstance = new WebAssembly.Instance(wasmModule, importObject, { builtins: [''] });
      }
      
      if (isDeno) {
        const path = await import(/* webpackIgnore: true */'https://deno.land/std/path/mod.ts');
        const binary = Deno.readFileSync(path.fromFileUrl(import.meta.resolve(wasmFilePath)));
        const module = await WebAssembly.compile(binary);
        wasmInstance = await WebAssembly.instantiate(module, importObject, { builtins: [''] });
      }
      
      if (isStandaloneJsVM) {
        const wasmBuffer = read(wasmFilePath, 'binary');
        const wasmModule = new WebAssembly.Module(wasmBuffer);
        wasmInstance = new WebAssembly.Instance(wasmModule, importObject, { builtins: [''] });
      }
      
      if (isBrowser) {
        wasmInstance = (await WebAssembly.instantiateStreaming(fetch(new URL('./SnakeMeasurer-composeApp.wasm',import.meta.url).href), importObject, { builtins: [''] })).instance;
      }
    } catch (e) {
      if (e instanceof WebAssembly.CompileError) {
        let text = `Please make sure that your runtime environment supports the latest version of Wasm GC and Exception-Handling proposals.
For more information, see https://kotl.in/wasm-help
`;
        if (isBrowser) {
          console.error(text);
        } else {
          const t = "\n" + text;
          if (typeof console !== "undefined" && console.log !== void 0) 
            console.log(t);
          else 
            print(t);
        }
      }
      throw e;
    }
    
    wasmExports = wasmInstance.exports;
    if (runInitializer) {
        wasmExports._initialize();
    }

    return { instance: wasmInstance,  exports: wasmExports };
}
